import { render } from "./modalOK.vue?vue&type=template&id=716bbf06"
import script from "./modalOK.vue?vue&type=script&lang=js"
export * from "./modalOK.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__